<template>
    <div>
        <label>Publicera och aktivera</label><br>
        <label class="radio-inline">
            <input type="radio" :value="true" v-model="localData.publish_and_activate" @change="emit()" /> Ja
        </label>
        <label class="radio-inline">
            <input type="radio" :value="false" v-model="localData.publish_and_activate" @change="emit()" /> Nej
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) },
        clinic: { required: true }
    },

    data () {
        return {
            localData: { publish_and_activate: true, ...this.value }
        }
    },

    created () {
        this.emit()
    },

    methods: {
        emit () {
            this.$emit('input', { ...this.localData })
        }
    }
}
</script>
